import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'secondary' | 'danger'

const VARIANT_STYLES: Record<Variant, string> = {
  primary: 'bg-primary text-white hover:bg-blue-700',
  secondary: 'border border-slate-300 bg-white text-slate-700 hover:bg-slate-50',
  danger: 'bg-danger text-white hover:bg-red-600',
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
}

export function Button({
  variant = 'primary',
  className = '',
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`rounded-lg px-3 py-2 text-sm font-medium transition-colors disabled:opacity-60 ${VARIANT_STYLES[variant]} ${className}`}
      {...props}
    />
  )
}
